var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.3,64H106.7C47.8,64.1,0.1,111.8,0,170.7v128c0.1,58.9,47.8,106.6,106.7,106.7h128v21.3h-64c-11.8,0-21.3,9.6-21.3,21.3 s9.6,21.3,21.3,21.3h170.7c11.8,0,21.3-9.6,21.3-21.3s-9.6-21.3-21.3-21.3h-64v-21.3h128c58.9-0.1,106.6-47.8,106.7-106.7v-128 C511.9,111.8,464.2,64.1,405.3,64z M469.3,298.7c0,35.3-28.7,64-64,64H106.7c-35.3,0-64-28.7-64-64v-128c0-35.3,28.7-64,64-64h298.7 c35.3,0,64,28.7,64,64V298.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLarge);
export default __webpack_public_path__ + "static/media/large.9b9b1967b27e2e466b5e0a0d0a9089fc.svg";
export { ForwardRef as ReactComponent };